import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { AI_COMPANION } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

interface TriggerAiCompanionExampleChatClickedEventParams {
	exampleChat: string;
}

export const triggerAiCompanionExampleChatClickedEvent = ({
	exampleChat,
}: TriggerAiCompanionExampleChatClickedEventParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: AI_COMPANION,
		customData: { label: exampleChat },
		name: 'dlr_ai_companion_example_chat_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
